function stateOfcheckbox() {
    $('.form__checkbox--all').on('click', function() {
        $('input:checkbox').not(this).prop('checked', this.checked);
    });
    $('.form__checkbox--inside').on('click', function() {
        $('.form__checkbox--inside').each(function () { 
            if (!$(this).is(':checked')) {
                $('.form__checkbox--all').prop('checked', false);
            }
        });
    });

    $('.form__arrow').on('click', function() {
        $(this).toggleClass('active');
        $('.form__acceptance--nested').toggleClass('active');
    })
}

function dropdown() {
    function hide() {
        $('.departments-modal').slideUp(200);
        $('.departments-modal__dropdown').removeClass('departments-modal__dropdown--active');
    }

    $('.departments-modal__dropdown').on('click', function() {
        $('.departments-modal').slideToggle(200);
        $('.departments-modal__dropdown').toggleClass('departments-modal__dropdown--active');
    });

    $('.departments-modal__close-btn').on('click', function() {
        hide();
    });

    $('html').on('click', function(e) {
        const modal = $(".departments-modal, .departments-modal__dropdown");
        if (!modal.is(e.target) && modal.has(e.target).length === 0 && $(e.target).closest(".departments-modal").length === 0) {
            hide();
        }
    });
}

function scrollToSection() {
    $('#menu-1 a').on('click', function (e) {
        e.preventDefault();
        $('.menu-toggle').removeClass('is-active');
        $('.topBar').removeClass('is-opened');
        
        var link = $(this).attr('href');
    
        $('html, body').animate({
            scrollTop: $(link).offset().top - 85
        }, 800);
        return false;
    });
    $('.btn-scroll').on('click', function(e) {
        let link = $(this).attr('href');
        
        if(link.slice(0,1) == '#'){
            e.preventDefault();
            $('html, body').animate({
                scrollTop: $(link).offset().top - 85
            }, 800);
            return false;
        }
    })
}

function scrollTop() {
    $('.scrollTop').on('click', function(e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 800);
        return false;
    });
}

function thankYouPage() {
    document.addEventListener( 'wpcf7mailsent', function( event ) {
        $('.thank-you').addClass('active');
        $('.thank-you__hidden').addClass('inactive');
    }, false );
}

function keyupForm() {
    const inputs = document.querySelectorAll('.wpcf7 input, .wpcf7 textarea');
 
    if (inputs.length > 0) {
       
        $('.wpcf7 input, .wpcf7 textarea').on('keyup', function() {
            $(this).siblings('.wpcf7-not-valid-tip').addClass('hide');
        });

    }
}



$(window).on('load', function() {
    stateOfcheckbox();
    scrollTop();
    scrollToSection();
    thankYouPage();
    dropdown();
    keyupForm();

    let AOS = require('aos');
    AOS.init({
        once: true,
        disable: 'phone'
    })
    
})


//////////////////
// WEBPACK FOOTER
// ./js/bscript.js
// module id = 4
// module chunks = 0